import anime from 'animejs'
import getOffsetLeft from '../utils/getOffsetLeft'
import onResize from '../utils/onResize'

import scenario1 from '../json/scenario1.json'
import scenario2 from '../json/scenario2.json'
import scenario3 from '../json/scenario3.json'
import scenario4 from '../json/scenario4.json'
import emitter from '../utils/emitter'

export default {
  name: 'script',

  mode: 'auto',
  prevScrollbar: 0,
  currentScrollbar: 0,
  initX: 0,
  firstX: 0,
  percentHours: [
    [0, '06'],
    [4.16, '07'],
    [8.32, '08'],
    [12.48, '09'],
    [16.64, '10'],
    [20.28, '11'],
    [24.96, '12'],
    [29.12, '13'],
    [33.28, '14'],
    [37.44, '15'],
    [41.6, '16'],
    [45.76, '17'],
    [49.92, '18'],
    [54.08, '19'],
    [58.24, '20'],
    [62.4, '21'],
    [66.56, '22'],
    [70.72, '23'],
    [74.88, '00'],
    [79.04, '01'],
    [83.2, '02'],
    [87.36, '03'],
    [91.52, '04'],
    [95.68, '05'],
    [100, '05'],
    [100, '05'],
  ],

  ui: {
    button: '[js-script-button]',
    timeline: '[js-script-timeline]',
    shadow: '[js-script-shadow]',
    'hours[]': '[js-script-hour]',
    graphWrap: '[js-script-graph-wrap]',
    consumedValue: '[js-script-consumed-value]',
    consumedBar: '[js-script-consumed-bar]',
    producedValue: '[js-script-produced-value',
    producedBar: '[js-script-produced-bar]',
    producedGEBar: '[js-script-produced-ge-bar]',
    producedGEValue: '[js-script-produced-ge-value]',
    producedENRValue: '[js-script-produced-enr-value]',
    producedENRBar: '[js-script-produced-enr-bar]',
    batteryBar: '[js-script-battery-bar]',
    batteryValue: '[js-script-battery-value]',
    overflow: '[js-script-overflow]',
  },

  events: [
    {
      on: 'mousedown',
      target: 'button',
      handle (e) {
        e.preventDefault()
  
        if (this.hasManualMode) {   
          this.switchManual()
          this.initX = e.target.offsetLeft
          this.firstX = e.pageX
  
          this.ui.button.classList.add('is-dragging')
          this.ui.button.addEventListener('mousemove', this.dragIt, false)
  
          window.addEventListener('mouseup', () => {
            this.ui.button.removeEventListener('mousemove', this.dragIt, false)
            this.ui.button.classList.remove('is-dragging')
          }, false)
        }
      },
    },
    {
      on: 'click',
      target: 'timeline',
      handle (e) {
        if (this.hasManualMode) {
          this.switchManual()      
        }
      },
    },
  ],

  switchManual () {
    if (this.mode === 'auto') {
      this.buttonAnim.pause()
      this.ui.button.style.left = `${parseFloat(this.ui.button.style.transform.replace('translateX(', '').replace('px)', '')) + 32}px`
      this.ui.button.style.transform = 'none'
      this.mode = 'manual'
    }
  },

  dragIt (e) {
    this.moveTimeline(e.pageX, 'manual')
  },

  swipeIt (e) {
    this.moveTimeline(e.touches[0].pageX, 'manual')
  },

  moveTimeline (pageX, mode, progress) {
    if (mode === 'manual') {
      this.prevScrollbar = this.currentScrollbar
      this.currentScrollbar = pageX
    }

    this.mode = mode
    // pos of button in px
    const pos = mode === 'auto' ? pageX : this.initX + pageX - this.firstX
    // get offsetLeft of timeline
    const timelineOffsetLeft = getOffsetLeft(this.ui.timeline)

    // get current hour based on pos on timeline
    this.getCurrentHour(pos, mode)

    // update valuesBar
    this.updateValueBar(this.ui.consumedValue, this.ui.consumedBar, 'consumedEnergy')
    this.updateValueBar(this.ui.producedValue, this.ui.producedBar, 'producedEnergy')
    this.updateValueBar(this.ui.producedGEValue, this.ui.producedGEBar, 'producedEnergyGE')
    this.updateValueBar(this.ui.producedENRValue, this.ui.producedENRBar, 'producedEnergyENR')
    this.updateValueBar(this.ui.batteryValue, this.ui.batteryBar, 'battery')

    // move to bottom current hour
    const activeHour = document.querySelector('[js-script-hour].is-active')
    const newHour = document.querySelector(`[js-script-hour][data-hour="${this.currentHour}"]`)

    newHour.classList.add('is-active')

    if (activeHour && activeHour !== newHour) {
      activeHour.classList.remove('is-active')
    }

    // move button + graphWrap reveal
    if (mode === 'manual') {
      if (pageX + 32 < timelineOffsetLeft + this.ui.timeline.offsetWidth + 8 && pageX - 32 > timelineOffsetLeft - 4) {
        this.ui.button.style.left = pos + 'px'
        this.ui.graphWrap.style.width = `${pos}px`
      }
    } else {
      this.ui.graphWrap.style.width = `${pos + 32}px`
    }

    if (pos > window.innerWidth - 128) {
      const scrollBy = this.currentScrollbar - this.prevScrollbar

      this.ui.overflow.scrollBy(scrollBy, 0)
    } else if (pos < 20) {
      this.ui.overflow.scrollTo(0, 0)
    }
  },

  updateValueBar (container, bar, type) {
    const value = this.script[type][this.currentHour]
    let percent = value * 100 / this.script[type].total
    container.innerHTML = value

    if (type === 'battery') {
      percent = 100 - percent
    }

    bar.style.transform = `scaleX(${percent / 100})`
  },

  getCurrentHour (pos, mode) {
    const newPos = mode === 'auto' ? pos + 32 : pos
    const percent = newPos * 100 / this.ui.timeline.offsetWidth
    let count = 0

    /* eslint-disable-next-line */
    while (percent > this.percentHours[count][0] && percent <= 100) {
      this.currentHour = this.percentHours[count][1]
      count++
    }

    // bottom shadow
    this.ui.shadow.style.transform = `scaleX(${1 - percent / 100})`

    // highlight pictos
    Object.values(this.script.pictos).forEach((picto, index) => {
      if (percent > picto - 1 && percent < picto + 1) {
        const tooltip = this.el.querySelector(`.script-tooltip--${index + 1}`)
        const picto = this.el.querySelector(`.script-picto-pos--${index + 1}`)

        const oldActiveTooltip = this.el.querySelector('.script-tooltip.is-active')
        const oldActivePicto = this.el.querySelector('.script-picto-pos.is-active')

        if (oldActiveTooltip) {
          oldActivePicto.classList.remove('is-active')
          oldActiveTooltip.classList.remove('is-active')
        }

        tooltip.classList.add('is-active')
        picto.classList.add('is-active')

        setTimeout(() => {
          tooltip.classList.remove('is-active')
          picto.classList.remove('is-active')
        }, 2000)
      }
    })
  },

  startAutoAnim () {
    this.buttonAnim = anime({
      targets: this.ui.button,
      translateX: this.timelineSize,
      loop: true,
      easing: 'linear',
      duration: 30000,
      update: (anim) => {
        const pos = Math.ceil(this.ui.button.style.transform.replace('translateX(', '').replace('px)', ''))
        this.prevScrollbar = this.currentScrollbar
        this.currentScrollbar = pos
        this.moveTimeline(pos, 'auto', anim.progress)
      },
    })
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    if (this.props.script === '1') {
      this.script = scenario1
    } else if (this.props.script === '2') {
      this.script = scenario2
    } else if (this.props.script === '3') {
      this.script = scenario3
    } else {
      this.script = scenario4
    }

    emitter.on('autoPlayScriptAnim', (datas) => {
      if (this.mode === 'auto' && ((datas.activeTab === undefined && this.props.script === '1') || datas.activeTab === this.props.script)) {
        if (this.buttonAnim) {
          if (datas.changeTab === undefined) {
            this.buttonAnim.play()
          } else {
            this.buttonAnim.restart()
          }
        } else {
          this.startAutoAnim()
        }
      }
    })

    emitter.on('stopScriptAnim', () => {
      if (this.buttonAnim) {
        this.buttonAnim.pause()
      }
    })
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.hasManualMode = true
    this.timelineSize = this.ui.timeline.offsetWidth - 64
  },
}
